// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"styles_ldsRing__AXHFG","ldsRingWhite":"styles_ldsRingWhite__nOFYG"};